// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file payment/v1/payment.proto (package payment.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { AchPaymentMethod, AchVerificationType, CancelRequestStatus, CaptureRequestStatus, CardNetwork, CardPresentPaymentMethod, CardPresentRefundRecord, CardType, CardTypeIndicators, CashPaymentMethod, CheckoutOptions, ConsumerActionCode, Device, EcpBankAccountType, EncryptedCard, EncryptedElectronicCheck, EncryptedPayByBank, EncryptedSepa, EncryptedStoredPaymentMethod, EncryptedWallet, Klarna as Klarna$1, Lpm as Lpm$1, LpmType, Money, NonceGenerationRequestStatus, OtherPaymentMethod, PaymentCardOrTokenPaymentMethod, PaymentGatewayType, PayRequestStatus, PreferredRoutingInitiator, RefundRequestStatus, RefundSplitOptions, StoredPaymentMethodUpdateDetails, TipRequestStatus, TokenizedPaymentMethod } from "../../common/v1/common_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { LineItem, Order } from "../../order/v1/order_pb";
import { BrowserInfo, ScaChallengeWindowSize, ThreeDsTransactionDetails } from "../../common/v1/three_domain_secure_pb";
import { IntentType } from "../../common/v1/session_pb";
import { CancelErrorCode, CaptureErrorCode, NonceGenerationErrorCode, PayRequestErrorCode, RefundErrorCode, TipErrorCode } from "../../common/v1/payment_errors_pb";
import { PaymentMethod as PaymentMethod$1 } from "../../common/v1/payment_pb";
import { PostalAddress } from "../../google/type/postal_address_pb";

/**
 * Defines possible outcomes of fraud check.
 *
 * @generated from enum payment.v1.FraudCheckStatus
 */
export const FraudCheckStatus = proto3.makeEnum(
  "payment.v1.FraudCheckStatus",
  [
    {no: 0, name: "FRAUD_CHECK_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FRAUD_CHECK_STATUS_SUCCESS", localName: "SUCCESS"},
    {no: 2, name: "FRAUD_CHECK_STATUS_FAILURE", localName: "FAILURE"},
    {no: 3, name: "FRAUD_CHECK_STATUS_TIMEOUT", localName: "TIMEOUT"},
    {no: 4, name: "FRAUD_CHECK_STATUS_NOT_REQUIRED", localName: "NOT_REQUIRED"},
    {no: 5, name: "FRAUD_CHECK_STATUS_IN_REVIEW", localName: "IN_REVIEW"},
  ],
);

/**
 * Defines the digital wallet type.
 *
 * @generated from enum payment.v1.WalletType
 */
export const WalletType = proto3.makeEnum(
  "payment.v1.WalletType",
  [
    {no: 0, name: "WALLET_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "WALLET_TYPE_APPLE_PAY", localName: "APPLE_PAY"},
    {no: 2, name: "WALLET_TYPE_GOOGLE_PAY", localName: "GOOGLE_PAY"},
    {no: 3, name: "WALLET_TYPE_PAZE", localName: "PAZE"},
  ],
);

/**
 * Defines a base transaction that contains attributes common to various transaction types such
 * DebitTransaction.
 *
 * Next Id: 16
 *
 * @generated from message payment.v1.Transaction
 */
export const Transaction = proto3.makeMessageType(
  "payment.v1.Transaction",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reference", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "shopper_reference", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "payment_gateway_type", kind: "enum", T: proto3.getEnumType(PaymentGatewayType) },
    { no: 6, name: "payment_gateway_mid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "safetech_merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "shopper_profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "amount", kind: "message", T: Money },
    { no: 11, name: "idempotency_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "safetech_kaptcha_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "created_at", kind: "message", T: Timestamp },
    { no: 14, name: "updated_at", kind: "message", T: Timestamp },
    { no: 15, name: "payment_gateway_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "platform_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines a debit transaction entity.
 *
 * There might be multiple debit transactions with the same {@code oderID}, but all of them
 * should meet the following constraints:
 *
 *   - Only one transaction could be in the PENDING state.
 *   - Only one transaction could be in the SUCCESS state.
 *   - None or many transactions could be in the FAILED state.
 *   - If there is a transaction in the PENDING state, then no transactions could be in the
 *       SUCCESS state and vice versa.
 *
 * These entities are persisted in the Payment Transaction Repository.
 *
 * Next Id: 5
 *
 * @generated from message payment.v1.DebitTransaction
 */
export const DebitTransaction = proto3.makeMessageType(
  "payment.v1.DebitTransaction",
  () => [
    { no: 1, name: "base", kind: "message", T: Transaction },
    { no: 2, name: "state", kind: "enum", T: proto3.getEnumType(DebitTransaction_State) },
    { no: 3, name: "pay_request_details", kind: "message", T: PayRequestDetails },
    { no: 4, name: "pay_result", kind: "message", T: PayRequestResult },
    { no: 5, name: "payment_event", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "event_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "partial_authorization_support", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "remaining_balance", kind: "message", T: Money },
  ],
);

/**
 * State of the debit transaction.
 *
 * @generated from enum payment.v1.DebitTransaction.State
 */
export const DebitTransaction_State = proto3.makeEnum(
  "payment.v1.DebitTransaction.State",
  [
    {no: 0, name: "STATE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STATE_PENDING", localName: "PENDING"},
    {no: 2, name: "STATE_SUCCESS", localName: "SUCCESS"},
    {no: 3, name: "STATE_FAILED", localName: "FAILED"},
    {no: 4, name: "STATE_CANCELED", localName: "CANCELED"},
    {no: 5, name: "STATE_PENDING_REVIEW", localName: "PENDING_REVIEW"},
    {no: 6, name: "STATE_IN_TRANSIT", localName: "IN_TRANSIT"},
    {no: 7, name: "STATE_PENDING_LPM", localName: "PENDING_LPM"},
    {no: 8, name: "STATE_PENDING_KLARNA", localName: "PENDING_KLARNA"},
  ],
);

/**
 * PayRequestDetails defines a set of request parameters.
 * Next Id: 25
 *
 * @generated from message payment.v1.PayRequestDetails
 */
export const PayRequestDetails = proto3.makeMessageType(
  "payment.v1.PayRequestDetails",
  () => [
    { no: 1, name: "checkout_options", kind: "message", T: CheckoutOptions },
    { no: 2, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reference", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "shopper_reference", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "encrypted_payment_method", kind: "message", T: EncryptedPaymentMethod },
    { no: 17, name: "payment_method", kind: "message", T: PaymentMethod },
    { no: 6, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "shopper_profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "amount", kind: "message", T: Money },
    { no: 9, name: "line_items", kind: "message", T: LineItem, repeated: true },
    { no: 10, name: "safetech_kaptcha_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "shopper_profile_details", kind: "message", T: ShopperProfileDetails },
    { no: 12, name: "settings_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "device_info", kind: "message", T: Device },
    { no: 14, name: "browser_info", kind: "message", T: BrowserInfo },
    { no: 15, name: "sca_challenge_window_size", kind: "enum", T: proto3.getEnumType(ScaChallengeWindowSize) },
    { no: 16, name: "billing_address_from_intent_billing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "save_payment_method_to_profile", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "make_default_payment_method", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 20, name: "order", kind: "message", T: Order },
    { no: 21, name: "lpm_payment_cancelled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 23, name: "partial_authorization_support", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 24, name: "device_fingerprint_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 25, name: "intent_type", kind: "enum", T: proto3.getEnumType(IntentType) },
  ],
);

/**
 * PayRequestResult defines results of a payment operation.
 * Next Id: 41
 *
 * @generated from message payment.v1.PayRequestResult
 */
export const PayRequestResult = proto3.makeMessageType(
  "payment.v1.PayRequestResult",
  () => [
    { no: 1, name: "fraud_check_result", kind: "message", T: FraudCheckResult },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(PayRequestStatus) },
    { no: 12, name: "error_code", kind: "enum", T: proto3.getEnumType(PayRequestErrorCode) },
    { no: 9, name: "detail_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "payment_gateway_shopper_profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "payment_gateway_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "mit_received_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "card_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "card_expiration_month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "card_expiration_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "card_type_indicators", kind: "message", T: CardTypeIndicators },
    { no: 16, name: "last_4_of_card_pan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "billing_postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "payment_gateway_response", kind: "message", T: PaymentGatewayResponse },
    { no: 10, name: "payment_gateway_payment_method_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "payment_gateway_mid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "sca_orchestration_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 25, name: "three_ds_transaction_details", kind: "message", T: ThreeDsTransactionDetails },
    { no: 23, name: "card_type_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "payment_method_tokenizations", kind: "message", T: TokenizedPaymentMethod, repeated: true },
    { no: 24, name: "shopper_email_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "masked_pan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "account_holder_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "approval_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 29, name: "payment_gateway_type", kind: "enum", T: proto3.getEnumType(PaymentGatewayType) },
    { no: 30, name: "payment_method", kind: "message", T: PaymentMethod$1 },
    { no: 31, name: "consent_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 32, name: "created_timestamp", kind: "message", T: Timestamp },
    { no: 33, name: "updated_timestamp", kind: "message", T: Timestamp },
    { no: 34, name: "payment_gateway_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 35, name: "partial_authorization", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 36, name: "order", kind: "message", T: Order, opt: true },
    { no: 37, name: "amount", kind: "message", T: Money, opt: true },
    { no: 38, name: "is_previous_response_used", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 39, name: "consumer_action_code", kind: "enum", T: proto3.getEnumType(ConsumerActionCode) },
    { no: 40, name: "debit_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines fraud check result.
 * Next Id: 3
 *
 * @generated from message payment.v1.FraudCheckResult
 */
export const FraudCheckResult = proto3.makeMessageType(
  "payment.v1.FraudCheckResult",
  () => [
    { no: 1, name: "fraud_check_status", kind: "enum", T: proto3.getEnumType(FraudCheckStatus) },
    { no: 2, name: "detail_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines a payment method.
 *
 * @generated from message payment.v1.EncryptedPaymentMethod
 * @deprecated
 */
export const EncryptedPaymentMethod = proto3.makeMessageType(
  "payment.v1.EncryptedPaymentMethod",
  () => [
    { no: 1, name: "encrypted_card", kind: "message", T: EncryptedCard, oneof: "payment_method" },
    { no: 2, name: "encrypted_electronic_check", kind: "message", T: EncryptedElectronicCheck, oneof: "payment_method" },
    { no: 3, name: "encrypted_wallet", kind: "message", T: EncryptedWallet, oneof: "payment_method" },
    { no: 4, name: "encrypted_stored_payment_method", kind: "message", T: EncryptedStoredPaymentMethod, oneof: "payment_method" },
    { no: 5, name: "encrypted_sepa", kind: "message", T: EncryptedSepa, oneof: "payment_method" },
    { no: 6, name: "encrypted_pay_by_bank", kind: "message", T: EncryptedPayByBank, oneof: "payment_method" },
  ],
);

/**
 * Defines a payment method.
 *
 * @generated from message payment.v1.PaymentMethod
 */
export const PaymentMethod = proto3.makeMessageType(
  "payment.v1.PaymentMethod",
  () => [
    { no: 1, name: "encrypted_card", kind: "message", T: EncryptedCard, oneof: "payment_method" },
    { no: 2, name: "encrypted_electronic_check", kind: "message", T: EncryptedElectronicCheck, oneof: "payment_method" },
    { no: 3, name: "encrypted_wallet", kind: "message", T: EncryptedWallet, oneof: "payment_method" },
    { no: 4, name: "encrypted_stored_payment_method", kind: "message", T: EncryptedStoredPaymentMethod, oneof: "payment_method" },
    { no: 5, name: "encrypted_sepa", kind: "message", T: EncryptedSepa, oneof: "payment_method" },
    { no: 6, name: "payment_card_or_token", kind: "message", T: PaymentCardOrTokenPaymentMethod, oneof: "payment_method" },
    { no: 7, name: "ach", kind: "message", T: AchPaymentMethod, oneof: "payment_method" },
    { no: 8, name: "lpm", kind: "message", T: Lpm$1, oneof: "payment_method" },
    { no: 9, name: "encrypted_pay_by_bank", kind: "message", T: EncryptedPayByBank, oneof: "payment_method" },
    { no: 10, name: "klarna", kind: "message", T: Klarna$1, oneof: "payment_method" },
  ],
);

/**
 * @generated from message payment.v1.PrepayInfo
 */
export const PrepayInfo = proto3.makeMessageType(
  "payment.v1.PrepayInfo",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchant_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "total", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "shopper_profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "settings_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 10, name: "application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "payment_gateway_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "payment_gateway_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message payment.v1.PrepayPaymentMethod
 */
export const PrepayPaymentMethod = proto3.makeMessageType(
  "payment.v1.PrepayPaymentMethod",
  () => [
    { no: 1, name: "other", kind: "message", T: OtherPaymentMethod, oneof: "prepay_payment_method" },
    { no: 2, name: "card_present", kind: "message", T: CardPresentPaymentMethod, oneof: "prepay_payment_method" },
    { no: 3, name: "cash", kind: "message", T: CashPaymentMethod, oneof: "prepay_payment_method" },
  ],
);

/**
 * Decrypted payment card details.
 *
 * @generated from message payment.v1.DecryptedCard
 */
export const DecryptedCard = proto3.makeMessageType(
  "payment.v1.DecryptedCard",
  () => [
    { no: 1, name: "card_holder_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "card_holder_first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "card_holder_last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "cvv", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "expiration_month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "expiration_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "billing_address", kind: "message", T: PostalAddress },
    { no: 7, name: "network", kind: "enum", T: proto3.getEnumType(CardNetwork) },
    { no: 8, name: "type", kind: "enum", T: proto3.getEnumType(CardType) },
    { no: 11, name: "pin_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "preferred_payment_network_routing", kind: "enum", T: proto3.getEnumType(CardNetwork), opt: true },
    { no: 13, name: "preferred_routing_initiator", kind: "enum", T: proto3.getEnumType(PreferredRoutingInitiator), opt: true },
  ],
);

/**
 * Decrypted electronic check details.
 *
 * @generated from message payment.v1.DecryptedElectronicCheck
 */
export const DecryptedElectronicCheck = proto3.makeMessageType(
  "payment.v1.DecryptedElectronicCheck",
  () => [
    { no: 1, name: "bank_routing_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dda_account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "bank_account_type", kind: "enum", T: proto3.getEnumType(EcpBankAccountType) },
    { no: 5, name: "ach_verification_type", kind: "enum", T: proto3.getEnumType(AchVerificationType) },
    { no: 4, name: "billing_address", kind: "message", T: PostalAddress },
  ],
);

/**
 * Decrypted electronic check details.
 *
 * @generated from message payment.v1.DecryptedPayByBank
 */
export const DecryptedPayByBank = proto3.makeMessageType(
  "payment.v1.DecryptedPayByBank",
  () => [
    { no: 1, name: "account_token_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "bank_account_type", kind: "enum", T: proto3.getEnumType(EcpBankAccountType) },
    { no: 3, name: "billing_address", kind: "message", T: PostalAddress },
    { no: 4, name: "pay_by_bank_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "account_holder_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines the decrypted digital card from wallet.
 *
 * @generated from message payment.v1.DecryptedDigitalCard
 */
export const DecryptedDigitalCard = proto3.makeMessageType(
  "payment.v1.DecryptedDigitalCard",
  () => [
    { no: 1, name: "card_holder_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dpan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "expiration_month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "expiration_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "three_ds_online_payment_cryptogram", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "three_ds_eci_indicator", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "merchant_token_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "last_4_of_fpan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "network", kind: "enum", T: proto3.getEnumType(CardNetwork) },
  ],
);

/**
 * Decrypted Payment Wallet details.
 *
 * @generated from message payment.v1.DecryptedWallet
 */
export const DecryptedWallet = proto3.makeMessageType(
  "payment.v1.DecryptedWallet",
  () => [
    { no: 1, name: "decrypted_digital_card", kind: "message", T: DecryptedDigitalCard },
    { no: 2, name: "wallet_type", kind: "enum", T: proto3.getEnumType(WalletType) },
    { no: 3, name: "billing_address", kind: "message", T: PostalAddress },
  ],
);

/**
 * Decrypted Stored Payment method details.
 *
 * @generated from message payment.v1.DecryptedStoredPaymentMethod
 */
export const DecryptedStoredPaymentMethod = proto3.makeMessageType(
  "payment.v1.DecryptedStoredPaymentMethod",
  () => [
    { no: 1, name: "payment_gateway_profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "payment_method_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "card_cvv", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "update_details", kind: "message", T: StoredPaymentMethodUpdateDetails },
    { no: 5, name: "stored_payment_type", kind: "enum", T: proto3.getEnumType(DecryptedStoredPaymentMethod_StoredPaymentType) },
  ],
);

/**
 * Defines the stored payment type.
 *
 * @generated from enum payment.v1.DecryptedStoredPaymentMethod.StoredPaymentType
 */
export const DecryptedStoredPaymentMethod_StoredPaymentType = proto3.makeEnum(
  "payment.v1.DecryptedStoredPaymentMethod.StoredPaymentType",
  [
    {no: 0, name: "STORED_PAYMENT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STORED_PAYMENT_TYPE_CARD", localName: "CARD"},
    {no: 2, name: "STORED_PAYMENT_TYPE_ECP", localName: "ECP"},
    {no: 3, name: "STORED_PAYMENT_TYPE_SEPA", localName: "SEPA"},
  ],
);

/**
 * Decrypted sepa details.
 *
 * @generated from message payment.v1.DecryptedSepa
 */
export const DecryptedSepa = proto3.makeMessageType(
  "payment.v1.DecryptedSepa",
  () => [
    { no: 1, name: "bic", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "iban", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "mandate_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "billing_address", kind: "message", T: PostalAddress },
    { no: 4, name: "shopper_email_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines a payment method.
 *
 * @generated from message payment.v1.DecryptedPaymentMethod
 */
export const DecryptedPaymentMethod = proto3.makeMessageType(
  "payment.v1.DecryptedPaymentMethod",
  () => [
    { no: 1, name: "decrypted_card", kind: "message", T: DecryptedCard, oneof: "payment_method" },
    { no: 2, name: "decrypted_electronic_check", kind: "message", T: DecryptedElectronicCheck, oneof: "payment_method" },
    { no: 3, name: "decrypted_wallet", kind: "message", T: DecryptedWallet, oneof: "payment_method" },
    { no: 4, name: "stored_payment_method", kind: "message", T: DecryptedStoredPaymentMethod, oneof: "payment_method" },
    { no: 6, name: "decrypted_sepa", kind: "message", T: DecryptedSepa, oneof: "payment_method" },
    { no: 7, name: "payment_card_or_token", kind: "message", T: PaymentCardOrTokenPaymentMethod, oneof: "payment_method" },
    { no: 8, name: "ach", kind: "message", T: AchPaymentMethod, oneof: "payment_method" },
    { no: 9, name: "lpm", kind: "message", T: Lpm, oneof: "payment_method" },
    { no: 10, name: "decrypted_pay_by_bank", kind: "message", T: DecryptedPayByBank, oneof: "payment_method" },
    { no: 11, name: "klarna", kind: "message", T: Klarna, oneof: "payment_method" },
    { no: 5, name: "original_stored_payment_method", kind: "message", T: DecryptedStoredPaymentMethod },
  ],
);

/**
 * @generated from message payment.v1.Klarna
 */
export const Klarna = proto3.makeMessageType(
  "payment.v1.Klarna",
  () => [
    { no: 1, name: "redirected_payment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "preferred_language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "payment_metadata_list", kind: "message", T: PaymentMetaData, repeated: true },
  ],
);

/**
 * @generated from message payment.v1.PaymentMetaData
 */
export const PaymentMetaData = proto3.makeMessageType(
  "payment.v1.PaymentMetaData",
  () => [
    { no: 1, name: "meta_data_attribute", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "meta_data_attribute_value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines EU LPMs.
 *
 * @generated from message payment.v1.Lpm
 */
export const Lpm = proto3.makeMessageType(
  "payment.v1.Lpm",
  () => [
    { no: 1, name: "lpm_type", kind: "enum", T: proto3.getEnumType(LpmType) },
    { no: 2, name: "merchant_return_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "billing_address", kind: "message", T: PostalAddress },
    { no: 4, name: "preferred_language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines Payment Gateway response.
 * NextId: 25
 *
 * @generated from message payment.v1.PaymentGatewayResponse
 */
export const PaymentGatewayResponse = proto3.makeMessageType(
  "payment.v1.PaymentGatewayResponse",
  () => [
    { no: 21, name: "response_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 1, name: "transaction_status_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "transaction_status_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "approval_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "host_response_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "host_reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "response_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "payment_brand_auth_response_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "payment_brand_auth_resp_code_category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "profile_status_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "profile_status_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "transaction_timestamp", kind: "message", T: Timestamp },
    { no: 10, name: "card_holder_verification_response_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "card_holder_verification_host_response_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "address_verification_response_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "network_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "address_verification_host_response_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "capture_requested", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "consumer_profile_response_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "consumer_profile_response_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "authentication_exemption_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "transaction_state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "payment_request_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "transaction_processor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 25, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 26, name: "partial_authorization", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 27, name: "payment_request", kind: "message", T: PaymentRequest },
    { no: 28, name: "partial_authorization_support", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 29, name: "remaining_auth_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 30, name: "total_authorized_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 31, name: "requested_authorization_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message payment.v1.PaymentRequest
 */
export const PaymentRequest = proto3.makeMessageType(
  "payment.v1.PaymentRequest",
  () => [
    { no: 1, name: "payment_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "payment_request_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "captures", kind: "message", T: Capture, repeated: true },
    { no: 4, name: "authorizations", kind: "message", T: Authorization, repeated: true },
    { no: 5, name: "refunds", kind: "message", T: Refund, repeated: true },
  ],
);

/**
 * @generated from message payment.v1.Refund
 */
export const Refund = proto3.makeMessageType(
  "payment.v1.Refund",
  () => [
    { no: 1, name: "refund_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "transaction_status_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message payment.v1.Capture
 */
export const Capture = proto3.makeMessageType(
  "payment.v1.Capture",
  () => [
    { no: 1, name: "capture_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "transaction_status_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "capture_remaining_refundable_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "transaction_status_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message payment.v1.Authorization
 */
export const Authorization = proto3.makeMessageType(
  "payment.v1.Authorization",
  () => [
    { no: 1, name: "authorization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "transaction_status_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "authorization_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * ProfileDetails defines profile of a shopper.
 * Next Id: 10
 *
 * @generated from message payment.v1.ShopperProfileDetails
 */
export const ShopperProfileDetails = proto3.makeMessageType(
  "payment.v1.ShopperProfileDetails",
  () => [
    { no: 1, name: "shopper_profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "payment_gateway_profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "middle_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "shipping_address", kind: "message", T: PostalAddress },
    { no: 9, name: "billing_address", kind: "message", T: PostalAddress },
  ],
);

/**
 * Payment profile.
 *
 * @generated from message payment.v1.PaymentProfile
 */
export const PaymentProfile = proto3.makeMessageType(
  "payment.v1.PaymentProfile",
  () => [
    { no: 2, name: "payment_gateway_profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 1, name: "payment_methods", kind: "message", T: PaymentMethodSummary, repeated: true },
    { no: 3, name: "consumer_action_code", kind: "enum", T: proto3.getEnumType(ConsumerActionCode) },
  ],
);

/**
 * Summary of a payment method.
 * NextId: 7
 *
 * @generated from message payment.v1.PaymentMethodSummary
 */
export const PaymentMethodSummary = proto3.makeMessageType(
  "payment.v1.PaymentMethodSummary",
  () => [
    { no: 1, name: "payment_method_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "billing_address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "billing_address", kind: "message", T: PostalAddress },
    { no: 3, name: "card", kind: "message", T: CardSummary, oneof: "payment_method" },
    { no: 4, name: "electronic_check", kind: "message", T: ElectronicCheckSummary, oneof: "payment_method" },
    { no: 6, name: "sepa", kind: "message", T: SepaSummary, oneof: "payment_method" },
    { no: 7, name: "pay_by_bank", kind: "message", T: PayByBankSummary, oneof: "payment_method" },
  ],
);

/**
 * Summary of a payment method for partial auth
 *
 * @generated from message payment.v1.PartialAuthPaymentMethod
 */
export const PartialAuthPaymentMethod = proto3.makeMessageType(
  "payment.v1.PartialAuthPaymentMethod",
  () => [
    { no: 1, name: "card", kind: "message", T: CardSummary, oneof: "payment_method" },
    { no: 2, name: "digital_wallet", kind: "message", T: DigitalWalletSummary, oneof: "payment_method" },
  ],
);

/**
 * Card summary.
 *
 * @generated from message payment.v1.CardSummary
 */
export const CardSummary = proto3.makeMessageType(
  "payment.v1.CardSummary",
  () => [
    { no: 1, name: "network", kind: "enum", T: proto3.getEnumType(CardNetwork) },
    { no: 2, name: "card_holder_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "first6", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "last4", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "expiration_month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "expiration_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * ECP summary.
 *
 * @generated from message payment.v1.ElectronicCheckSummary
 */
export const ElectronicCheckSummary = proto3.makeMessageType(
  "payment.v1.ElectronicCheckSummary",
  () => [
    { no: 1, name: "bank_account_type", kind: "enum", T: proto3.getEnumType(EcpBankAccountType) },
    { no: 2, name: "bank_routing_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "dda_account_number_last4", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "account_holder_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * SEPA summary.
 *
 * @generated from message payment.v1.SepaSummary
 */
export const SepaSummary = proto3.makeMessageType(
  "payment.v1.SepaSummary",
  () => [
    { no: 1, name: "iban_last4", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "account_holder_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * PbB summary.
 *
 * @generated from message payment.v1.PayByBankSummary
 */
export const PayByBankSummary = proto3.makeMessageType(
  "payment.v1.PayByBankSummary",
  () => [
    { no: 1, name: "tokenized_account_last4", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Digital wallet summary.
 *
 * @generated from message payment.v1.DigitalWalletSummary
 */
export const DigitalWalletSummary = proto3.makeMessageType(
  "payment.v1.DigitalWalletSummary",
  () => [
    { no: 1, name: "card_expiration_month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "card_expiration_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "last_4_of_card_pan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * RefundRequestDetails defines a set of request parameters.
 *
 * @generated from message payment.v1.RefundRequestDetails
 */
export const RefundRequestDetails = proto3.makeMessageType(
  "payment.v1.RefundRequestDetails",
  () => [
    { no: 1, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "merchant_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "settings_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "split_options", kind: "message", T: RefundSplitOptions },
    { no: 9, name: "payment_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "card_present_refund_details", kind: "message", T: CardPresentRefundRecord },
  ],
);

/**
 * Defines Payment Gateway Refund response.
 *
 * @generated from message payment.v1.PaymentGatewayRefundResponse
 */
export const PaymentGatewayRefundResponse = proto3.makeMessageType(
  "payment.v1.PaymentGatewayRefundResponse",
  () => [
    { no: 1, name: "transaction_status_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "transaction_status_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "host_response_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "response_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "response_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "transaction_reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "transaction_timestamp", kind: "message", T: Timestamp },
    { no: 8, name: "merchant_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "remaining_refundable_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 13, name: "transaction_state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "payment_request_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "host_reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "response_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * RefundRequestResult defines results of a refund operation.
 *
 * @generated from message payment.v1.RefundRequestResult
 */
export const RefundRequestResult = proto3.makeMessageType(
  "payment.v1.RefundRequestResult",
  () => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(RefundRequestStatus) },
    { no: 2, name: "error_code", kind: "enum", T: proto3.getEnumType(RefundErrorCode) },
    { no: 3, name: "detail_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "payment_gateway_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "payment_gateway_refund_response", kind: "message", T: PaymentGatewayRefundResponse },
    { no: 6, name: "approval_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "payment_gateway_type", kind: "enum", T: proto3.getEnumType(PaymentGatewayType) },
    { no: 8, name: "payment_gateway_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * TipRequestResult defines results of a tip operation.
 *
 * @generated from message payment.v1.TipRequestResult
 */
export const TipRequestResult = proto3.makeMessageType(
  "payment.v1.TipRequestResult",
  () => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(TipRequestStatus) },
    { no: 2, name: "error_code", kind: "enum", T: proto3.getEnumType(TipErrorCode) },
    { no: 3, name: "detail_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "payment_gateway_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "payment_gateway_patch_response", kind: "message", T: PaymentGatewayPatchResponse },
    { no: 6, name: "approval_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "payment_gateway_type", kind: "enum", T: proto3.getEnumType(PaymentGatewayType) },
    { no: 8, name: "payment_gateway_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message payment.v1.TipRequestDetails
 */
export const TipRequestDetails = proto3.makeMessageType(
  "payment.v1.TipRequestDetails",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "total", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "merchant_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "settings_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * NonceGenerationResult defines results of nonce generation
 *
 * @generated from message payment.v1.NonceGenerationResult
 */
export const NonceGenerationResult = proto3.makeMessageType(
  "payment.v1.NonceGenerationResult",
  () => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(NonceGenerationRequestStatus) },
    { no: 2, name: "error_code", kind: "enum", T: proto3.getEnumType(NonceGenerationErrorCode) },
    { no: 3, name: "detail_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "nonce_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "expiration_timestamp", kind: "message", T: Timestamp },
  ],
);

/**
 * Defines a refund transaction entity.
 *
 * There might be multiple refund transactions with the same {@code oderID} and {@code paymentGatewayTransactionId}
 * , but all of them should meet the following constraints:
 *
 *   - Only one transaction could be in the PENDING state.
 *   - Only one transaction could be in the SUCCESS state.
 *   - None or many transactions could be in the FAILED state.
 *   - If there is a transaction in the PENDING state, then no transactions could be in the
 *       SUCCESS state and vice versa.
 *
 * These entities are persisted in the Payment Transaction Repository.
 *
 *
 * @generated from message payment.v1.RefundTransaction
 */
export const RefundTransaction = proto3.makeMessageType(
  "payment.v1.RefundTransaction",
  () => [
    { no: 1, name: "base", kind: "message", T: Transaction },
    { no: 2, name: "state", kind: "enum", T: proto3.getEnumType(RefundTransaction_State) },
    { no: 3, name: "refund_request_details", kind: "message", T: RefundRequestDetails },
    { no: 4, name: "refund_result", kind: "message", T: RefundRequestResult },
    { no: 5, name: "payment_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "card_present_refund_details", kind: "message", T: CardPresentRefundRecord },
    { no: 7, name: "upg_event_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "last_updated_event_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * State of the refund transaction.
 *
 * @generated from enum payment.v1.RefundTransaction.State
 */
export const RefundTransaction_State = proto3.makeEnum(
  "payment.v1.RefundTransaction.State",
  [
    {no: 0, name: "STATE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STATE_PENDING", localName: "PENDING"},
    {no: 2, name: "STATE_SUCCESS", localName: "SUCCESS"},
    {no: 3, name: "STATE_FAILED", localName: "FAILED"},
    {no: 4, name: "STATE_STARTED_MARKETPLACE_WORKFLOW", localName: "STARTED_MARKETPLACE_WORKFLOW"},
    {no: 5, name: "STATE_PENDING_REVIEW", localName: "PENDING_REVIEW"},
  ],
);

/**
 * CancelRequestDetails defines a set of request parameters.
 *
 * @generated from message payment.v1.CancelRequestDetails
 */
export const CancelRequestDetails = proto3.makeMessageType(
  "payment.v1.CancelRequestDetails",
  () => [
    { no: 1, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "merchant_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "settings_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "payment_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines Payment Gateway Patch response.
 *
 * @generated from message payment.v1.PaymentGatewayPatchResponse
 */
export const PaymentGatewayPatchResponse = proto3.makeMessageType(
  "payment.v1.PaymentGatewayPatchResponse",
  () => [
    { no: 1, name: "transaction_status_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "transaction_status_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "host_response_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "response_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "response_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "original_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "transaction_timestamp", kind: "message", T: Timestamp },
    { no: 8, name: "merchant_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "is_void", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "transaction_state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "host_reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "response_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * CancelRequestResult defines results of a cancel operation.
 *
 * @generated from message payment.v1.CancelRequestResult
 */
export const CancelRequestResult = proto3.makeMessageType(
  "payment.v1.CancelRequestResult",
  () => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(CancelRequestStatus) },
    { no: 2, name: "error_code", kind: "enum", T: proto3.getEnumType(CancelErrorCode) },
    { no: 3, name: "detail_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "payment_gateway_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "payment_gateway_patch_response", kind: "message", T: PaymentGatewayPatchResponse },
    { no: 6, name: "approval_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "payment_gateway_type", kind: "enum", T: proto3.getEnumType(PaymentGatewayType) },
    { no: 8, name: "payment_gateway_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines a cancel transaction entity.
 *
 * There might be multiple cancel transactions with the same {@code oderID} and {@code paymentGatewayTransactionId}
 * , but all of them should meet the following constraints:
 *
 *   - Only one transaction could be in the PENDING state.
 *   - Only one transaction could be in the SUCCESS state.
 *   - None or many transactions could be in the FAILED state.
 *   - If there is a transaction in the PENDING state, then no transactions could be in the
 *       SUCCESS state and vice versa.
 *
 * These entities are persisted in the Payment Transaction Repository.
 *
 *
 * @generated from message payment.v1.CancelTransaction
 */
export const CancelTransaction = proto3.makeMessageType(
  "payment.v1.CancelTransaction",
  () => [
    { no: 1, name: "base", kind: "message", T: Transaction },
    { no: 2, name: "state", kind: "enum", T: proto3.getEnumType(CancelTransaction_State) },
    { no: 3, name: "cancel_request_details", kind: "message", T: CancelRequestDetails },
    { no: 4, name: "cancel_result", kind: "message", T: CancelRequestResult },
    { no: 5, name: "payment_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * State of the cancel transaction.
 *
 * @generated from enum payment.v1.CancelTransaction.State
 */
export const CancelTransaction_State = proto3.makeEnum(
  "payment.v1.CancelTransaction.State",
  [
    {no: 0, name: "STATE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STATE_PENDING", localName: "PENDING"},
    {no: 2, name: "STATE_SUCCESS", localName: "SUCCESS"},
    {no: 3, name: "STATE_FAILED", localName: "FAILED"},
  ],
);

/**
 * Defines Pay by bank account access consent response.
 *
 * @generated from message payment.v1.PayByBankAccountAccessConsentResponse
 */
export const PayByBankAccountAccessConsentResponse = proto3.makeMessageType(
  "payment.v1.PayByBankAccountAccessConsentResponse",
  () => [
    { no: 1, name: "transaction_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "response_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "response_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "response_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "consumer_user_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "consumer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "link", kind: "message", T: Link },
  ],
);

/**
 * Link for Pay by bank contains consent url.
 *
 * @generated from message payment.v1.Link
 */
export const Link = proto3.makeMessageType(
  "payment.v1.Link",
  () => [
    { no: 1, name: "consent_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message payment.v1.GetPrePaymentInfoRequestResult
 */
export const GetPrePaymentInfoRequestResult = proto3.makeMessageType(
  "payment.v1.GetPrePaymentInfoRequestResult",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchant_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "total", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "shopper_profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "settings_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "payment_method", kind: "message", T: PrepayPaymentMethod },
    { no: 10, name: "metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 11, name: "created_at", kind: "message", T: Timestamp },
    { no: 12, name: "updated_at", kind: "message", T: Timestamp },
    { no: 13, name: "transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "prepayment_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines Upg Payment Event for sales activity.
 *
 * @generated from message payment.v1.UpgPaymentEvent
 */
export const UpgPaymentEvent = proto3.makeMessageType(
  "payment.v1.UpgPaymentEvent",
  () => [
    { no: 1, name: "transaction_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "transaction_request_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "transaction_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "transaction_currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "masked_account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "payment_processor_authorization_response_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "sales_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "payment_type_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "transaction_status_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "refundable_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "remaining_refundable_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 13, name: "payment_method_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "payment_brand_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "last_updated_event_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "address_postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "address_country_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "transaction_capture_method_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "transaction_timestamp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "create_timestamp", kind: "message", T: Timestamp },
    { no: 21, name: "update_timestamp", kind: "message", T: Timestamp },
    { no: 22, name: "checkout_payment_request_external_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "payment_authorization_response_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines a capture transaction entity.
 *
 * These entities are persisted in the Payment Transaction Repository.
 *
 *
 * @generated from message payment.v1.CaptureTransaction
 */
export const CaptureTransaction = proto3.makeMessageType(
  "payment.v1.CaptureTransaction",
  () => [
    { no: 1, name: "base", kind: "message", T: Transaction },
    { no: 2, name: "state", kind: "enum", T: proto3.getEnumType(CaptureTransaction_State) },
    { no: 3, name: "capture_request_details", kind: "message", T: CaptureRequestDetails },
    { no: 4, name: "capture_result", kind: "message", T: CaptureRequestResult },
  ],
);

/**
 * State of the capture transaction.
 *
 * @generated from enum payment.v1.CaptureTransaction.State
 */
export const CaptureTransaction_State = proto3.makeEnum(
  "payment.v1.CaptureTransaction.State",
  [
    {no: 0, name: "STATE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STATE_PENDING", localName: "PENDING"},
    {no: 2, name: "STATE_SUCCESS", localName: "SUCCESS"},
    {no: 3, name: "STATE_FAILED", localName: "FAILED"},
  ],
);

/**
 * CaptureRequestResult defines results of a capture operation.
 *
 * @generated from message payment.v1.CaptureRequestResult
 */
export const CaptureRequestResult = proto3.makeMessageType(
  "payment.v1.CaptureRequestResult",
  () => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(CaptureRequestStatus) },
    { no: 2, name: "error_code", kind: "enum", T: proto3.getEnumType(CaptureErrorCode) },
    { no: 3, name: "detail_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "payment_gateway_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "payment_gateway_patch_response", kind: "message", T: PaymentGatewayPatchResponse },
    { no: 6, name: "approval_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "payment_gateway_type", kind: "enum", T: proto3.getEnumType(PaymentGatewayType) },
    { no: 8, name: "payment_gateway_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message payment.v1.CaptureRequestDetails
 */
export const CaptureRequestDetails = proto3.makeMessageType(
  "payment.v1.CaptureRequestDetails",
  () => [
    { no: 1, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "merchant_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "settings_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

